import { gql } from '@common/hooks';
import { SimpleFileFragment, SimpleFileFragmentType } from './file';

export const CommentInfoFragment = gql`
  fragment CommentInfoFragment on Comment {
    id
    contentAsText
    createdAt
    updatedAt
    external
    author {
      id
      name
      entity: entityProvider {
        ... on Organization {
          id
          name
        }
        ... on Supplier {
          id
          name
        }
      }
    }
  }
`;

export type CommentInfoFragmentType = {
  id: string;
  contentAsText: string;
  createdAt: string;
  updatedAt: string;
  external: boolean;
  author: {
    id: string;
    name: string;
    entity?: {
      id: string;
      name: string;
    } | null;
  };
};

export const CommentWithFileInfoFragment = gql`
  fragment CommentWithFileInfoFragment on Comment {
    id
    contentAsText
    createdAt
    updatedAt
    author {
      id
      name
      entity: entityProvider {
        ... on Organization {
          id
          name
        }
        ... on Supplier {
          id
          name
        }
      }
    }
    files {
      ...SimpleFileFragment
    }
  }
  ${SimpleFileFragment}
`;

export type CommentWithFileInfoFragmentType = {
  id: string;
  contentAsText: string;
  createdAt: string;
  updatedAt: string;
  author: {
    id: string;
    name: string;
    entity: {
      id: string;
      name: string;
    };
  };
  files: SimpleFileFragmentType[];
};
